import PropTypes from "prop-types";
import NoResults from "../../../components/noResults/NoResults";
import NoSearchResults from "../../../components/noSearchResults";
import NoVideoResult from "../../../images/cloud-arrow-up.svg?react";

function VideosNoResults(props) {
  const descriptionMarkup = (
    <span>
      Looks like you don't have any uploaded videos yet.
      <br />
      Drag and drop files here to upload.
    </span>
  );

  return props.filtered ? (
    <NoSearchResults />
  ) : (
    <NoResults
      title="No videos. Drag & Drop files here to upload."
      description={descriptionMarkup}
      icon={<NoVideoResult />}
    >
      {props.createAssetButton}
    </NoResults>
  );
}

VideosNoResults.propTypes = {
  filtered: PropTypes.bool,
  createAssetButton: PropTypes.object,
};

export default VideosNoResults;
